import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-action-delete-cell-renderer',
  templateUrl: './ag-action-delete-cell-renderer.component.html',
  styleUrls: ['./ag-action-delete-cell-renderer.component.css']
})
export class AgActionDeleteCellRendererComponent implements OnInit, ICellRendererAngularComp {
  public params: any;
  deleteDisabled = false;
  constructor() { }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
    this.deleteDisabled = params.deleteDisabled;
  }

  refresh(): boolean {
    return false;
  }

  onDelete() {
    this.params.context.componentParent.onDelete(this.params.data);
  }

}
